<template>
    <transition name="warning-container">
        <div class="warning-popup warning d-flex justify-content-end align-items-start">
            <div class="warning-container col-xl-6 col-lg-8 col-10 neue-roman" :class="this.warningType">
                <div class="warning-wrapper d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                        <div class="warning-picture" :class="this.warningType">
                            <svg v-if="this.warningType === 'error'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16.5v.01"/></svg>
                            <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 16v-5M12 8h.01"/></svg>
                        </div>
                        <div class="warning-text-info">
                            <div class="warning-text">
                                {{ this.warningText ? this.warningText : '' }}
                            </div>
                        </div>
                    </div>
                    <div>
                        <i class="item-i error-close c20 pointer" role="button" tabindex="0" :aria-label="$t('views.Login.50')" @click="this.closePopup()" @keydown.enter="this.closePopup()" @keydown.space.prevent="this.closePopup()"/>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {}
    },
    props: {
        warningType: [String],
        warningText: [String],
        warningCode: [String]
    },
    methods: {
        closePopup() {
            this.$emit('close', {
            })
        }
    },
}
</script>

<style lang="scss" scoped>
    .warning-popup { 
        width: 100%;
        outline: none;
        overflow: auto;
        opacity: 0;
        animation: ani 0.3s forwards;
        padding: 0 8px;

        @media (min-width: 516px) {
            padding-right: 40px;
        }
    }

    @keyframes ani {
        0% {opacity: 0;}
        100% {opacity: 1;}
    }

    // Auth redesign — тост белой карточкой с цветным акцентом слева (токены).
    .warning-container {
        width: 100%;
        color: var(--ink);
        padding: 15px 18px;
        border-radius: 14px;
        background: #fff;
        border: 1px solid var(--line);
        border-left: 4px solid var(--line-strong);
        box-shadow: 0 18px 40px -16px rgba(20, 22, 40, .28), 0 2px 6px rgba(20, 22, 40, .06);

        @media (min-width: 516px) {
            max-width: 420px;
        }
    }

    .warning-text {
        font-size: 14px;
        line-height: 1.45;
    }

    .warning-picture,
    .warning-text-info {
        margin-right: 16px;
    }
    .warning-picture { display: flex; align-items: center; }
    .warning-picture svg { width: 24px; height: 24px; }
    .warning-picture.error { color: var(--danger); }
    .warning-picture.warning-info { color: var(--ink-faint); }

    .warning-info {
        border-left-color: var(--ink-faint);
    }

    .error {
        border-left-color: var(--danger);
    }
</style>